export default function ColorBox(props) {
    return <div style={{ width: 24, height: 24, backgroundColor: props.color }}></div>;
}
